/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TeamSearchResultDTO { 
    id: string;
    name: string;
    competition_name?: string | null;
    category_name?: string | null;
    gender?: number | null;
}

